import Swiper from 'swiper/bundle'
import constants from '../lib/constants'
import $ from 'jquery'

export default class {
  constructor(element) {
    if (!element) {
      return false
    }

    this.wrap = jQuery(element)
    this.swiper = null
    this.items = this.wrap.find('.s-user-carousel__item').length - 1

    //this.isMobile = window.matchMedia("(max-width: 767px)").matches;

 

    $(window).on("resize", ()=>{
      this._iniSlider()
    })

    this.initSwiper()
  }

  initSwiper() {
    var isMobile = window.matchMedia('(max-width: 767px)').matches

    var swiperOptions = {
      pagination: {
        clickable: true,
        el: '.s-user-carousel .swiper-pagination',
      },
      autoplay:{
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        780: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1520: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
      },
      on: {
        init: () => {
          var activeIndex = this.activeIndex

          if (activeIndex === this.items) {
            $('.s-user-carousel').removeClass('opacity')
          } else {
            $('.s-user-carousel').addClass('opacity')
          }
        },
        slideChange: () => {
          var activeIndex = this.activeIndex

          if (activeIndex === this.items) {
            $('.s-user-carousel').removeClass('opacity')
          } else {
            $('.s-user-carousel').addClass('opacity')
          }
        },
      },
    }

    // if (isMobile) {
    //   swiperOptions.autoplay = {
    //     delay: 4000,
    //     disableOnInteraction: false,
    //   }
    // }

    if (this.swiper) {
      this.swiper.destroy(true, true) // Destroy the existing Swiper instance
    }

    this.swiper = new Swiper(this.wrap[0], swiperOptions)
  }

 
}
